import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateTechnicianIaModeOverride } from '../services/AIInspectionManagerService';
export default function useUpdateTechnicianIaModeOverride() {
    const queryClient = useQueryClient();
    const updateTechnicianOverride = useMutation(({ technicianId, iaModeOverride }) => updateTechnicianIaModeOverride(technicianId, iaModeOverride), {
        onSettled: () => {
            void queryClient.invalidateQueries(['aiInspectionManagerSettings']);
        }
    });
    return { updateTechnicianOverride };
}
